import React, { useEffect, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import dayjs from "dayjs";
import _ from "lodash";
import weekOfYear from "dayjs/plugin/weekOfYear";
dayjs.extend(weekOfYear);

am5.addLicense("AM5C363108325");
am5.addLicense("AM5M363108325");

const MultiLineChart = ({ activePeriod, chartData, productivity, activeType}) => {


console.log(chartData)

  const unit = productivity.split(" ").slice(1).join("");
  const averagesByPeriod = calculateAverageByPeriod(chartData, activePeriod);

console.log(averagesByPeriod)


  useEffect(() => {
    let root = am5.Root.new("chartdiv");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: true,
      panY: false,
      wheelX: "panX",
      wheelY: "zoomX",
      maxTooltipDistance: 0,
      pinchZoomX: true
    }));

    chart.zoomOutButton.set("forceHidden", true);

    
    let xRenderer = am5xy.AxisRendererX.new(root, {});
    let yRenderer = am5xy.AxisRendererY.new(root, {});
    xRenderer.grid.template.setAll({
      strokeOpacity: 0,
    });
    xRenderer.labels.template.setAll({
      paddingTop: 10,
      scale: 0.8,
    });
    yRenderer.grid.template.setAll({
      strokeOpacity: 0,
    });
    yRenderer.labels.template.setAll({});

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "date",
        renderer:xRenderer
      })
    );

    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      renderer: yRenderer,
      extraMax: 0.2 // Y축 최대값에 추가할 여유 공간 비율
    }));

    xAxis.set("tooltip", am5.Tooltip.new(root, {
      themeTags: ["axis"]
    }));
    

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    for (let i = 0; i < averagesByPeriod.length; i++) {
      let series = chart.series.push(am5xy.LineSeries.new(root, {
        name: averagesByPeriod[i].projectName,
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        categoryXField: "date",
        legendValueText:  activeType ==="물량" ? "{valueY.formatNumber('#,###.0000')}": "{valueY.formatNumber('#,###.')}" ,
        // fill: "#0C4DA2",
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
          labelText: activeType ==="물량" ? "{name}: [bold]{valueY.formatNumber('#,###.0000')}" +" "+unit: "{name}: {valueY.formatNumber('#,###.')}" +" "+unit,

        })
      }));
      xAxis.data.setAll(averagesByPeriod[i].data);
      series.data.setAll(averagesByPeriod[i].data);

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 3,
            fill: "#fff",
            // stroke: "#0C4DA2",
            stroke: series.get("fill"),
            strokeWidth: 3,
          }),
        });
      });

      series.bullets.push(function () {
        let label = am5.Label.new(root, {
          text: activeType ==="물량" ? "{valueY.formatNumber('#,###.0000')}": "{valueY.formatNumber('#,###.')}" ,
          centerY: am5.p100,
          centerX: am5.p50,
          populateText: true,
          textAlign: "center",
        });
        label.adapters.add("text", function (text, target) {
          if (target.dataItem && target.dataItem.get("valueY") === 0) {
            return "";
          }
          return text;
        });
        return am5.Bullet.new(root, {
          sprite: label,
          // stroke: series.get("fill")
        });
      });
      series.strokes.template.setAll({
        strokeWidth: 2,
        // stroke: series.get("fill")
      });
      series.appear();
    }


    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none"
    }));
    cursor.lineY.set("visible", false);


    // Add scrollbar
    // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
    chart.set("scrollbarX", am5.Scrollbar.new(root, {
      orientation: "horizontal",
      maxHeight: 5,
    }));


    let scrollbarX = chart.get("scrollbarX");

    scrollbarX.startGrip.setAll({
      visible: false,
    });
    scrollbarX.endGrip.setAll({
      visible: false,
    });
    chart.bottomAxesContainer.children.push(scrollbarX);
    // Add legend
    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
    let legend = chart.rightAxesContainer.children.push(am5.Legend.new(root, {
      width: 220,
      paddingLeft: 15,
      height: am5.percent(100)
    }));


    legend.itemContainers.template.set("width", am5.p100);
    legend.valueLabels.template.setAll({
      width: am5.p100,
      textAlign: "right"
    });
    legend.markers.template.setAll({
      width: 5,
      height: 3
    });

    // It's is important to set legend data after all the events are set on template, otherwise events won't be copied
    legend.data.setAll(chart.series.values);


    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(1000, 100);

    return () => {
      root && root.dispose();
    };
  }, [averagesByPeriod]);


  return <div id="chartdiv" style={{ height: "530px" }} />;
}
 
export default MultiLineChart;

function calculateAverageByPeriod(data, period) {
  // 주차 계산 함수
  const getWeek = (date) => {
    return dayjs(date).week();
  };

  // 날짜 포맷 함수
  const formatDate = (date, timeUnit) => {
    if (timeUnit === "month") {
      // 월 기준으로 그룹화할 때는, 날짜를 해당 월의 첫날로 설정
      return dayjs(date).startOf('month').format("YY년 MM월");
    } else if (timeUnit === "week") {
      // 주 기준으로 그룹화할 때는, 날짜를 해당 주의 첫날로 설정
      return `${dayjs(date).startOf('week').format("YY년 ")} ${getWeek(date)}주차`;
    } else {
      // 일 기준으로 그룹화
      return dayjs(date).format("YYYY년 MM월 DD일");
    }
  };

  // 데이터 그룹화 및 계산
  const result = data.map(project => {
    const groupedData = project.data.reduce((acc, item) => {
      const formattedDate = formatDate(item.date, period);
      if (!acc[formattedDate]) {
        acc[formattedDate] = { quantitySum: 0, manhourSum: 0 };
      }
      acc[formattedDate].quantitySum += item.quantityValue || 0;
      acc[formattedDate].manhourSum += item.manhourValue|| 0;
      return acc;
    }, {});


    const averages = Object.keys(groupedData).map(formattedDate => {
      const { quantitySum, manhourSum } = groupedData[formattedDate];
      const averageValue = manhourSum > 0 ? quantitySum / manhourSum : 0;
      return { date: formattedDate, value: averageValue };
    });

    return { projectName: project.projectName, data: averages };
  });

  return result;
}